module.exports = __webpack_public_path__ + "static/media/01.881f7717.png";